export default __webpack_public_path__ + "static/media/cloud-check.64c912db.svg";